<template>
  <div class="content">
    <PraticeIntroSection />
    <PraticeCommunicationAndMarketingSection />
    <PraticeCommunicationAndMarketingPostSection />
    <PraticeThemeEsgManisfestSection />
    <PraticeThemeEsgBlacknessSection />
    <PraticeExplanatoryTopicsSection />
    <PraticeExplanatoryTopicsDomSection />
    <PraticeSensitiveTopicsSection />
    <PraticeSensitiveTopicsTecSection />
    
  </div>
</template>

<script lang="ts">

import PraticeIntroSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeIntroSection.vue';
import PraticeCommunicationAndMarketingSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeCommunicationAndMarketingSection.vue'
import PraticeCommunicationAndMarketingPostSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeCommunicationAndMarketingPostSection.vue'
import PraticeThemeEsgManisfestSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeThemeEsgManisfestSection.vue'
import PraticeThemeEsgBlacknessSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeThemeEsgBlacknessSection.vue'
import PraticeExplanatoryTopicsSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeExplanatoryTopicsSection.vue'
import PraticeExplanatoryTopicsDomSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeExplanatoryTopicsDomSection.vue' 
import PraticeSensitiveTopicsSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeSensitiveTopicsSection.vue'  
import PraticeSensitiveTopicsTecSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeSensitiveTopicsTecSection.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {    
    PraticeIntroSection,
    PraticeCommunicationAndMarketingSection,
    PraticeCommunicationAndMarketingPostSection,
    PraticeThemeEsgManisfestSection,
    PraticeThemeEsgBlacknessSection,
    PraticeExplanatoryTopicsSection,
    PraticeExplanatoryTopicsDomSection,
    PraticeSensitiveTopicsSection,
    PraticeSensitiveTopicsTecSection
    
  }
})
export default class PraticeView extends Vue {}
</script>

<style lang="scss"></style>
